import api from './client';

export const getSOPEntries = () =>
  api.get('/admin/sops').then(r => r.data);

export const getSOPEntry = (id) =>
  api.get(`/admin/sops/${id}`).then(r => r.data);

export const createSOPEntry = (data) =>
  api.post('/admin/sops', data).then(r => r.data);

export const updateSOPEntry = (id, data) =>
  api.put(`/admin/sops/${id}`, data).then(r => r.data);

export const deleteSOPEntry = (id) =>
  api.delete(`/admin/sops/${id}`).then(r => r.data);

export const uploadSOPFile = (sopId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/admin/sops/${sopId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export const deleteSOPFile = (sopId, fileId) =>
  api.delete(`/admin/sops/${sopId}/files/${fileId}`).then(r => r.data);

export const reprocessSOPEntry = (sopId) =>
  api.post(`/admin/sops/${sopId}/reprocess`).then(r => r.data);

export const getSOPStats = () =>
  api.get('/admin/sops/stats/overview').then(r => r.data);
